var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "arrow-left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.15 11.1 22.02 9 6 25.02 22.05 41.1l2.13-2.1-12.423-12.45H42v-3H11.7z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "audio",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.5 3.06h-3v42h3zM16.5 15.06h-3v18h3zM4.5 9.06h3v30h-3zM40.5 33.03h3v-18h-3zM34.5 39.03h-3v-30h3z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "book",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M33 18H15v3h18zM15 12h18v3H15z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42 45H12.45C8.88 45 6 42.3 6 39V9c0-3.3 2.88-6 6.45-6h26.4C40.59 3 42 4.35 42 6v30H12.45C10.56 36 9 37.35 9 39s1.56 3 3.45 3H42zM12.45 6C10.56 6 9 7.35 9 9v24.93c.99-.6 2.19-.93 3.45-.93H39V6z",
    clipRule: "evenodd"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "brochure",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42 7.83h-.3L30 10.17 18.3 7.83h-.54l-12 2.4c-.69.15-1.2.75-1.2 1.47v26.94c0 .84.69 1.5 1.5 1.5h.3l11.7-2.34 11.7 2.34h.54l12-2.4c.69-.15 1.2-.75 1.2-1.47V9.33c0-.84-.69-1.5-1.5-1.5M7.5 12.96l9-1.8v23.88l-9 1.8zm12-1.8 9 1.8v23.88l-9-1.8zm21 23.88-9 1.8V12.96l9-1.8z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "budget",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M31.5 18c0 4.14-3.36 7.5-7.5 7.5s-7.5-3.36-7.5-7.5 3.36-7.5 7.5-7.5 7.5 3.36 7.5 7.5m-3 0c0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 16.53H9v3h6zM33 16.53h6v3h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 30V6h42v24zM6 9v18h36V9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 32.97v3h36v-3zM9 42v-3h30v3z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M39 6h-6V3h-3v3H17.99V3h-3v3H9C7.34 6 6 7.34 6 9v30c0 1.66 1.34 3 3 3h30c1.66 0 3-1.34 3-3V9c0-1.66-1.34-3-3-3m0 33H9V19.5h30zm0-22.5H9V9h5.99v3h3V9H30v3h3V9h6z",
    clipRule: "evenodd"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "camera",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 16.5c-4.98 0-9 4.02-9 9s4.02 9 9 9 9-4.02 9-9-4.02-9-9-9m0 3c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M30 13.5h9v3h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42 7.5H6c-1.65 0-3 1.35-3 3v27c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3v-27c0-1.65-1.35-3-3-3m0 3v27H6v-27z",
    clipRule: "evenodd"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "chain",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.55 30.75a6.56 6.56 0 0 0 4.68 1.95c1.77 0 3.42-.69 4.68-1.95l10.56-10.56a6.627 6.627 0 0 0 0-9.36l-2.1-2.1a6.627 6.627 0 0 0-9.36 0l-5.28 5.28 2.97 2.97 5.28-5.28c.93-.93 2.49-.93 3.42 0l2.1 2.1c.93.93.93 2.49 0 3.42L29.94 27.78c-.93.9-2.52.9-3.42 0l-3.15-3.15-2.97 2.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 39.27c1.29 1.29 3 1.92 4.68 1.92 1.71 0 3.39-.63 4.68-1.92l5.31-5.31-2.97-2.97-5.31 5.31c-.96.96-2.49.93-3.42 0l-2.1-2.1c-.93-.96-.93-2.49 0-3.42l10.56-10.56c.96-.96 2.49-.93 3.42 0l3.18 3.18 2.97-2.97-3.18-3.18a6.627 6.627 0 0 0-9.36 0L4.5 27.81a6.627 6.627 0 0 0 0 9.36z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    id: "check",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.47 36.87 5.95 23.36l2.12-2.12 11.4 11.39 20.46-20.44 2.12 2.13z",
    clipRule: "evenodd"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "check-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 2c12.198 0 22 9.81 22 22s-9.81 22-22 22S2 36.19 2 24 11.81 2 24 2m9.25 14-11 10.667-5.5-5.334L14 24l8 8 14-13.333z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m22.5 24.63 8.22 8.07 2.1-2.16-7.32-7.17V12h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 24C3 12.39 12.39 3 24 3s21 9.39 21 21-9.39 21-21 21S3 35.61 3 24m39 0c0-9.93-8.07-18-18-18S6 14.07 6 24s8.07 18 18 18 18-8.07 18-18",
    clipRule: "evenodd"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "clock-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21S35.598 3 24 3m-1.5 9h3v11.37l7.32 7.17-2.1 2.16-8.22-8.07z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 8.01 39.99 6 24 21.99 8.01 6 6 8.01 21.99 24 6 39.99 8.01 42 24 26.01 39.99 42 42 39.99 26.01 24z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "close-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3s21 9.402 21 21m-13.59-9.54 2.13 2.13L26.1 24l7.44 7.41-2.13 2.13L24 26.13l-7.44 7.41-2.1-2.13L21.87 24l-7.41-7.41 2.1-2.13L24 21.87z",
    clipRule: "evenodd"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "close-outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.868 24.021-7.425 7.425 2.122 2.121 7.424-7.424 7.425 7.424 2.121-2.121-7.424-7.425 7.424-7.424-2.121-2.122-7.425 7.425-7.424-7.425-2.122 2.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 3C12.42 3 3 12.42 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m0 3c9.93 0 18 8.07 18 18s-8.07 18-18 18S6 33.93 6 24 14.07 6 24 6",
    clipRule: "evenodd"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    id: "copy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M39 10.4H18c-1.7 0-3 1.4-3 3.1v28.3c0 1.7 1.3 3.1 3 3.1h10.8c.8 0 1.6-.3 2.1-.9l10.2-10.7c.6-.6.9-1.4.9-2.2V13.5c0-1.7-1.3-3.1-3-3.1m-9 30.2V33h7.3zM18.1 42s-.1 0-.1-.2V13.4h21V30h-9c-1.7 0-3 1.3-3 3v9",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.4 33.1 5.9 9.8c-.1-1.2.3-2.4 1.1-3.3S8.9 5.1 10.1 5l19.8-1.9.3 3L10.3 8c-.4 0-.8.2-1.1.5-.2.3-.3.7-.3 1.1l1.5 23.3z",
    clipRule: "evenodd"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "corner-arrow",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m45 33.12-2.73 2.82-18.24-18.36L5.73 36 3 33.18 24.03 12z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "data",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M40.5 18c0-1.8-.81-3.39-2.07-4.5 1.26-1.11 2.07-2.7 2.07-4.5 0-3.3-2.7-6-6-6h-21c-3.3 0-6 2.7-6 6 0 1.8.81 3.39 2.07 4.5C8.31 14.61 7.5 16.2 7.5 18s.81 3.39 2.07 4.5C8.31 23.61 7.5 25.2 7.5 27c0 3.3 2.7 6 6 6h9v2.82a4.9 4.9 0 0 0-3.21 3.21H9v3h10.29c.63 2.01 2.49 3.48 4.71 3.48s4.08-1.47 4.71-3.48H39v-3H28.71a4.9 4.9 0 0 0-3.21-3.21V33h9c3.3 0 6-2.7 6-6 0-1.8-.81-3.39-2.07-4.5 1.26-1.11 2.07-2.7 2.07-4.5M24 42.48c-1.08 0-1.98-.87-1.98-1.98s.87-1.98 1.98-1.98 1.98.87 1.98 1.98-.87 1.98-1.98 1.98M10.5 8.97c0-1.65 1.35-3 3-3h21c1.65 0 3 1.35 3 3s-1.35 3-3 3h-21c-1.65 0-3-1.35-3-3m27 18c0 1.65-1.35 3-3 3h-21c-1.65 0-3-1.35-3-3s1.32-2.97 2.97-3h21.06c1.65 0 2.97 1.35 2.97 3m-3-6H13.47c-1.65 0-2.97-1.35-2.97-3s1.35-3 3-3h21c1.65 0 3 1.35 3 3s-1.32 2.97-2.97 3z",
    clipRule: "evenodd"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "digital",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M31.77 13.5H18.63L14.28 18H6v-3h7.02l4.35-4.5h14.4c.66-2.16 2.64-3.75 5.01-3.75 2.88 0 5.25 2.37 5.25 5.25s-2.37 5.25-5.25 5.25c-2.37 0-4.35-1.59-5.01-3.75m7.26-1.5c0-1.23-1.02-2.25-2.25-2.25s-2.25 1.02-2.25 2.25 1.02 2.25 2.25 2.25 2.25-1.02 2.25-2.25M31.77 34.5c.66-2.16 2.64-3.75 5.01-3.75 2.88 0 5.25 2.37 5.25 5.25s-2.37 5.25-5.25 5.25c-2.37 0-4.35-1.59-5.01-3.75H20.04l-2.82-6H6v-3h11.19l2.79-6.03h5.76c.63-2.16 2.64-3.78 5.01-3.78 2.88 0 5.25 2.37 5.25 5.25s-2.37 5.25-5.25 5.25c-2.34 0-4.32-1.59-4.98-3.72h-3.84l-2.1 4.56 2.1 4.47zm1.29-10.59c0-1.23-1.02-2.25-2.25-2.25s-2.25 1.02-2.25 2.25 1.02 2.25 2.25 2.25 2.25-1.02 2.25-2.25M34.53 36c0 1.23 1.02 2.25 2.25 2.25s2.25-1.02 2.25-2.25-1.02-2.25-2.25-2.25-2.25 1.02-2.25 2.25",
    clipRule: "evenodd"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "document",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 13.5H12v3h12zM30 19.5H12v3h18z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M37.5 4.74v25.29h6v7.47c0 3.3-2.91 6-6.51 6H12c-4.14 0-7.5-3.36-7.5-7.5V4.74zM12 40.5c2.58 0 5.16-1.38 5.16-4.5v-5.97H34.5V7.74h-27V36c0 2.49 1.92 4.5 4.5 4.5m24.99 0c1.95 0 3.51-1.35 3.51-3v-4.47H20.16V36c0 1.74-.54 3.27-1.5 4.5z",
    clipRule: "evenodd"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    id: "download",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M37.9 17.8 25.5 30.2V3h-3v27.3L10 17.9 7.9 20 24 36l16-16.1zM39 36v6H9v-6H6v6c0 1.7 1.3 3 3 3h30c1.7 0 3-1.3 3-3v-6z",
    clipRule: "evenodd"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m39.54 6.81 4.53 4.53c.51.54.81 1.26.81 1.98s-.3 1.44-.81 1.95L25.98 33.36c-.33.33-.69.57-1.11.69l-7.47 1.8c-.15.09-.3.09-.48.09-.48 0-.99-.18-1.38-.57-.51-.51-.69-1.29-.48-1.98l1.74-7.26c.15-.51.39-.93.72-1.23L35.61 6.81a2.79 2.79 0 0 1 3.93 0M18.36 32.58l5.73-1.38 12.45-12.54-4.26-4.26-12.63 12.63zm19.2-23.49-3.18 3.18 4.26 4.26v.03l3.18-3.21z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 41.94h30v-15h3v15c0 1.65-1.35 3-3 3H9c-1.65 0-3-1.35-3-3v-30c0-1.65 1.35-3 3-3h15.03v3H9z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "email",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42.18 9H5.88A2.88 2.88 0 0 0 3 11.88v24.27a2.88 2.88 0 0 0 2.88 2.88h36.3a2.88 2.88 0 0 0 2.88-2.88V11.88A2.88 2.88 0 0 0 42.18 9m-.12 3-.12-.15h.12zm-2.07-.12L23.97 27.03 8.19 12l31.77-.12zM6.03 12l-.15.15V12zm0 24.12-.12-22.2L21.9 29.19c.57.54 1.32.84 2.07.84s1.47-.27 2.07-.81l16.05-15.15v21.96l-36.03.12z",
    clipRule: "evenodd"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "energy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M38.85 31.29 27.6 24.81c-.6.54-1.32.96-2.1 1.2v15.96H33v3H15v-3h7.5V26.01c-.81-.24-1.5-.66-2.1-1.2L9.15 31.29l-1.5-2.61L18.9 22.2c-.09-.39-.15-.78-.15-1.2 0-2.37 1.59-4.35 3.75-5.01V3h3v12.99c2.16.66 3.75 2.64 3.75 5.01 0 .42-.06.81-.15 1.2l11.25 6.48zM24 18.75c-1.23 0-2.25 1.02-2.25 2.25s1.02 2.25 2.25 2.25 2.25-1.02 2.25-2.25-1.02-2.25-2.25-2.25",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.67 10.23c-5.07 1.29-8.16 6.45-6.87 11.52l-2.91.72C6.21 15.81 10.29 9 16.95 7.32z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "error",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.988 6c-.42 0-.81.24-1.05.6l-9.78 16.8c-.21.36-.21.84 0 1.2l9.809 16.8c.21.36.6.6 1.05.6h19.62c.42 0 .81-.24 1.05-.6l9.811-16.8c.21-.36.21-.84 0-1.2l-9.81-16.8c-.21-.36-.601-.6-1.051-.6zm2.293 8.467 7.424 7.424 7.426-7.424 2.121 2.12-7.426 7.425 7.426 7.426-2.121 2.12-7.426-7.423-7.424 7.424-2.12-2.121 7.423-7.426-7.424-7.424z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "euro",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.72 30.24c1.65 1.71 3.63 2.55 6 2.55l.03.06c2.58 0 4.74-1.05 6.6-3.21l.78-.93v4.14l-.15.12c-1.95 1.74-4.41 2.61-7.26 2.61-3.15 0-5.82-1.11-7.95-3.33-1.23-1.26-2.1-2.79-2.64-4.53h-3.69l1.17-2.76h2.01c-.06-.3-.06-.6-.06-.93 0-.139.016-.27.031-.397.015-.12.029-.236.029-.353h-3.18l1.17-2.76h2.49c.54-1.83 1.44-3.39 2.7-4.71 2.13-2.22 4.8-3.33 7.95-3.33s5.85 1.14 8.04 3.42l.21.21-1.17 2.79-.48-.54c-1.89-2.13-4.05-3.15-6.6-3.15-2.37 0-4.35.84-6 2.55-.78.81-1.35 1.71-1.77 2.73h14.1l-1.11 2.76H16.32c-.06.24-.06.48-.06.75 0 .3.03.63.06.93h13.26l-1.17 2.76h-11.4c.42.96.99 1.8 1.71 2.55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.06 24c0-11.61 9.39-21 21-21s21 9.39 21 21-9.39 21-21 21-21-9.39-21-21m39 0c0-9.93-8.07-18-18-18s-18 8.07-18 18 8.07 18 18 18 18-8.07 18-18",
    clipRule: "evenodd"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "external",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4H6v36h36v-8h4v12H2V2zm32 0v20h-4V8.667l-.201.404-16.97 16.97L22 23.214l16.97-16.97.484-.243H26V2z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "external-events",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M39 6h-6V3h-3v3H18V3h-3v3H9C7.35 6 6 7.35 6 9v30c0 1.65 1.35 3 3 3h9v-3H9V9h6v3h3V9h12v3h3V9h6v9h3V9c0-1.65-1.35-3-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M33 21v3h6.81l-7.86 7.95 2.1 2.1L42 26.07V33h3V21z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 42h15v-6h3v6c0 1.65-1.35 3-3 3H24c-1.65 0-3-1.35-3-3V27c0-1.65 1.35-3 3-3h6v3h-6z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "faq",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M28.65 12.39c-1.26-1.05-3.06-1.56-5.31-1.56-1.68 0-3.6.48-5.7 1.44l-.27.12.09.27.84 2.13.12.3.3-.15c1.8-.84 3.3-1.26 4.44-1.26q1.89 0 2.97.9c.72.6 1.05 1.44 1.05 2.58 0 .69-.18 1.35-.48 1.95-.33.6-.87 1.23-1.59 1.83l-2.31 2.04c-1.35 1.2-2.04 2.88-2.04 4.98v1.29h3v-1.26c0-.63.06-1.17.21-1.56.15-.42.33-.75.57-1.05s.93-.9 2.04-1.83c2.67-2.22 4.02-4.41 4.02-6.51s-.66-3.6-1.92-4.65zM22.53 32.37q-.9 0-1.53.63c-.42.42-.63.93-.63 1.56q0 .945.63 1.62c.42.45.93.69 1.53.69s1.14-.24 1.56-.69q.63-.675.63-1.62c0-.63-.21-1.14-.63-1.56s-.93-.63-1.56-.63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 3h36c1.65 0 3 1.35 3 3v36c0 1.65-1.35 3-3 3H6c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3m36 39V6H6v36z",
    clipRule: "evenodd"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "feedback",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.05 35.43q.405.18.81.18c.39 0 .72-.12.93-.3l11.25-6.87H34.5c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3H6C4.35 3 3 4.35 3 6v19.47c0 1.65 1.35 3 3 3h3.03v5.34c0 .69.39 1.32 1.02 1.62m.27-2.73s-.21.09-.27.18zM6 25.44V6h28.53v19.44h-12.3l-10.2 6.21v-6.21z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M33.03 42.66c.33.27.72.42 1.14.42l-.03-.03c.27 0 .54-.06.78-.18.63-.3 1.02-.93 1.02-1.62v-5.34h6.03c1.65 0 3-1.35 3-3V11.97c0-1.65-1.35-3-3-3v23.97h-9.03V39l-9-6.06h-4.59v3h3.69zm1.68-2.46.12.09s-.06-.06-.12-.09",
    clipRule: "evenodd"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "file",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M33 11.7H15v2.1h18zM15 16.68h18v2.1H15z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M36 3H12c-1.65 0-3 1.35-3 3v36c0 1.65 1.35 3 3 3h13.77c.81 0 1.56-.33 2.13-.87L38.13 33.9c.57-.57.87-1.32.87-2.13V6c0-1.65-1.35-3-3-3M11.1 42V6c0-.51.39-.9.9-.9h24c.51 0 .9.39.9.9v25.14h-8.31c-1.98 0-3.6 1.62-3.6 3.63v8.13H12.03c-.51 0-.9-.39-.9-.9zm15.99-.06v-7.17c0-.84.66-1.53 1.5-1.53h7.2z",
    clipRule: "evenodd"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "folder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42 15H25.47l-4.38-8.16c-.27-.51-.84-.84-1.44-.84H4.59C3.69 6 3 6.66 3 7.5V39c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3V18c0-1.65-1.35-3-3-3M6 9h12.84l3.21 6H6zm36 30H6V18h36z",
    clipRule: "evenodd"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "fullscreen",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.22 6 10.86 10.95-2.16 2.1L6 8.01V18H3V3h15v3zM30 6V3h15v15h-3V8.01L31.05 19.05l-2.1-2.1L39.78 6zM16.95 28.95 6 39.96V30H3v14.97h15v-3H8.22l10.83-10.92zM42 39.96V30h3v14.97H30v-3h9.78L28.95 31.05l2.1-2.1z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "global",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M45 24c0-11.6-9.4-21-21-21S3 12.4 3 24c0 11 8.4 20 19.2 20.9.6.1 1.2.1 1.8.1s1.2 0 1.8-.1C36.5 44 45 35 45 24M24.6 42h-1.2c-1.9-1.8-5.1-6.4-5.4-16.5h12c-.3 10.1-3.4 14.6-5.4 16.5m17.3-19.5H33c-.2-7.8-2-12.7-3.9-15.8 7 2.1 12.2 8.3 12.8 15.8M24.7 6c1.9 1.8 5 6.3 5.3 16.5H18c.3-10.1 3.4-14.6 5.3-16.5zm-5.8.8c-1.9 3.1-3.7 8-3.9 15.7H6.1C6.7 15 11.9 8.8 18.9 6.8M6.1 25.5H15c.2 7.8 2.1 12.8 4 15.8C12 39.2 6.7 33 6.1 25.5M29 41.3c1.9-3 3.8-8 4-15.8h8.9C41.3 33 36 39.2 29 41.3"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "growth",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.35 41.97H39v-3H10.35c-.78 0-1.38-.75-1.38-1.65V9h-3v28.32c0 2.58 1.98 4.65 4.38 4.65"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 12V9h15v15h-3v-9.87L24.33 25.77l-8.28 8.28-2.1-2.1L33.87 12z"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "hamburger",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42 12H6v3h36zM42 33H6v3h36zM42 22.5H6v3h36z"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "image",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.543 32.97 3.013 9.66c-.09-1.2.3-2.34 1.08-3.27.78-.9 1.89-1.44 3.09-1.53L26.983 3l.27 3-19.83 1.86c-.87.06-1.5.78-1.44 1.59l1.56 23.34-3 .21z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.573 26.85c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5m0-6.45c1.08 0 1.95.87 1.95 1.95s-.87 1.95-1.95 1.95-1.95-.87-1.95-1.95.87-1.95 1.95-1.95",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.103 11.88h27c1.65 0 3 1.35 3 3v27c0 1.65-1.35 3-3 3h-27c-1.65 0-3-1.35-3-3v-27c0-1.65 1.35-3 3-3m0 30h27v-8.4l-6.06-6.54-8.58 8.25c-1.05 1.05-2.82 1.11-3.96.06L21.043 33l-5.94 6.45zm26.97-12.872.03.032h-.03zm-3.84-4.138 3.84 4.138V14.85h-27v20.22l3.93-4.17c1.11-1.17 2.88-1.2 4.05-.15l2.46 2.25 8.61-8.22c.51-.51 1.2-.84 2.04-.81.78.03 1.53.33 2.07.9",
    clipRule: "evenodd"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "infographic",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 3h12v36H3zm3 33h6V6H6zM18 9h12v30H18zm3 27h6V12h-6zM33 15v24h12V15zm9 21h-6V18h6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 42h42v3H3z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "information",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v36a3 3 0 0 0 3 3h36a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm18 9c.6 0 1.17.24 1.59.66s.66.99.66 1.59a2.307 2.307 0 0 1-1.41 2.1c-.39.15-.84.21-1.29.12-.42-.09-.84-.33-1.14-.63-.33-.3-.54-.69-.63-1.14-.09-.42-.06-.87.12-1.29s.48-.78.84-1.02c.39-.27.81-.39 1.26-.39m-4.5 9h6v12H30v3H18v-3h4.5v-9h-3z"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "laco",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.038 25.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M27.038 28.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6M39.038 25.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.918 12h30.24c1.62 0 2.91 1.35 2.91 3v21c0 1.65-1.32 3-2.91 3h-30.21c-1.62 0-2.91-1.35-2.91-3v-3.87l-5.49-5.34c-.72-.75-.72-1.83-.06-2.52l5.58-5.4-.06-3.87c0-1.65 1.32-3 2.91-3m.12 24h30l.03.06v-21h-30.12l.09 3.87c0 .78-.3 1.5-.81 2.07l-4.68 4.53 4.62 4.47c.57.6.87 1.35.87 2.13z",
    clipRule: "evenodd"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "laco-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42.158 12h-30.24c-1.59 0-2.91 1.35-2.91 3l.06 3.87-5.58 5.4c-.66.69-.66 1.77.06 2.52l5.49 5.34V36c0 1.65 1.29 3 2.91 3h30.21c1.59 0 2.91-1.35 2.91-3V15c0-1.65-1.29-3-2.91-3m-24.12 16.5c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m9 0c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m9 0c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3",
    clipRule: "evenodd"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "list",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.44 13.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M13.47 12H42v3H13.47zM13.47 33H42v3H13.47zM42 22.5H13.47v3H42zM8.19 26.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M10.44 34.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "livestreaming",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m11.415 10.875.015.015v-.03zM11.415 10.875 9.3 8.76c-8.4 8.4-8.4 22.08 0 30.48l2.13-2.13c-7.225-7.225-7.23-19.004-.015-26.235M36.57 10.89l2.13-2.13v.03c8.4 8.4 8.4 22.08 0 30.48l-2.13-2.13c7.23-7.23 7.23-19.02 0-26.25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m33.75 14.85-2.13 2.13c3.87 3.87 3.87 10.2 0 14.1l2.13 2.13c5.04-5.04 5.04-13.26 0-18.33zM21.03 21.03a4.183 4.183 0 0 0 0 5.94c.78.78 1.86 1.23 2.97 1.23s2.19-.45 2.97-1.23a4.183 4.183 0 0 0 0-5.94c-1.59-1.59-4.35-1.59-5.94 0M14.22 14.85c-5.04 5.04-5.04 13.26 0 18.33l2.13-2.13c-3.87-3.87-3.87-10.2 0-14.1l-2.13-2.13z"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    id: "location",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 6c3.6.01 6.99 1.41 9.54 3.96s3.96 5.94 3.96 9.54c0 2.9-.96 5.77-2.71 8.08l-.05.06c-.1.13-.33.43-.37.49L24 40.36 13.67 28.18l-.45-.59a13.4 13.4 0 0 1-2.71-8.08c0-3.61 1.41-6.99 3.96-9.54C17.01 7.41 20.4 6.01 24 6m0-3c-4.37.01-8.57 1.75-11.66 4.84A16.55 16.55 0 0 0 7.5 19.5c-.01 3.57 1.16 7.05 3.32 9.9l.52.68L24 45l12.66-14.93c.07-.08.52-.67.52-.67 2.16-2.85 3.33-6.32 3.32-9.9-.01-4.37-1.75-8.57-4.84-11.66A16.55 16.55 0 0 0 24 3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 15c2.48 0 4.5 2.02 4.5 4.5S26.48 24 24 24s-4.5-2.02-4.5-4.5S21.52 15 24 15m0-3c-4.14 0-7.5 3.36-7.5 7.5S19.86 27 24 27s7.5-3.36 7.5-7.5S28.14 12 24 12",
    clipRule: "evenodd"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "log-in",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.2 6.7c3.8 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7m0-3.7c-5.8 0-10.6 4.7-10.6 10.6s4.7 10.6 10.6 10.6 10.6-4.7 10.6-10.6S30 3 24.2 3M42.7 45.4h-3.6v-6c0-4.9-3.6-8.9-8-8.9H17.4c-4.4 0-8 4-8 8.9v6H5.8v-6c0-6.9 5.2-12.5 11.6-12.5H31c6.4 0 11.6 5.6 11.6 12.5.1 0 .1 6 .1 6"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "logged-in",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m30.7 47.1-9-9 2.6-2.5 6.4 6.4 12-12.1 2.6 2.6zM24 6.6c3.8 0 6.9 3.1 6.9 6.9s-3.1 6.9-6.9 6.9-6.9-3.1-6.9-6.9 3.1-6.9 6.9-6.9M24 3c-5.8 0-10.5 4.7-10.5 10.5S18.2 24 24 24s10.5-4.7 10.5-10.5S29.8 3 24 3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.4 45H5.8v-5.9c0-6.8 5.2-12.4 11.5-12.4h15.8v3.6H17.3c-4.4 0-8 4-8 8.8.1 0 .1 5.9.1 5.9"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "minus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 26v-4h32v4z"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "multiple-files",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m6.013 9.66 1.56 23.31V33l3-.21-1.56-23.34c-.03-.39.09-.78.36-1.08.24-.3.6-.51 1.05-.51L30.253 6l-.27-3-19.8 1.86c-1.2.09-2.31.63-3.09 1.53-.78.93-1.17 2.07-1.08 3.27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.133 10.26h21c1.65 0 3 1.41 3 3.15v17.55c0 .84-.3 1.62-.87 2.22l-10.23 10.74c-.57.6-1.32.93-2.13.93h-10.77c-1.65 0-3-1.41-3-3.15V13.41c0-1.74 1.35-3.15 3-3.15m12 22.59v7.68l7.32-7.68zm-12 8.85c0 .12.06.15.06.15h8.91v-9c0-1.65 1.35-3 3-3h9V13.41c0-.09-.03-.15-.03-.15h-20.94c.03.03 0 .15 0 .15z",
    clipRule: "evenodd"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "organigram",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M40.5 28.5h-4.89l-8.16-9H30c.81 0 1.5-.66 1.5-1.5V9c0-.84-.69-1.5-1.5-1.5H18c-.84 0-1.5.66-1.5 1.5v9c0 .84.66 1.5 1.5 1.5h2.55l-8.16 9H7.5c-.84 0-1.5.66-1.5 1.5v9c0 .81.66 1.5 1.5 1.5h12c.84 0 1.5-.69 1.5-1.5v-9c0-.84-.66-1.5-1.5-1.5h-3.03L24 20.16l7.53 8.34H28.5c-.84 0-1.5.66-1.5 1.5v9c0 .84.66 1.5 1.5 1.5h12c.84 0 1.5-.66 1.5-1.5v-9c0-.84-.66-1.5-1.5-1.5m-21-12v-6h9v6zm-1.5 15v6H9v-6zm21 6h-9v-6h9z",
    clipRule: "evenodd"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "package",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.51 22.5H9.99v3h17.52zM24 28.5H9.99v3H24z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m38.52 3.78 5.88 8.85.03-.03c.39.57.6 1.26.6 1.95v26.97c0 1.95-1.59 3.51-3.51 3.51H6.51C4.56 45.03 3 43.44 3 41.52V14.58c0-.69.21-1.38.6-1.95l5.88-8.85c.33-.48.87-.78 1.47-.78h26.1c.6 0 1.14.3 1.47.78m2.88 9.72L36.39 6H25.5v7.5zM22.5 6H11.61L6.6 13.5h15.9zm18.99 36c.3 0 .51-.24.51-.51V16.5H6v24.99c0 .3.24.51.51.51z",
    clipRule: "evenodd"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "pause",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 15h-3v18h3zM27 15h3v18h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m0 3c9.93 0 18 8.07 18 18s-8.07 18-18 18S6 33.93 6 24 14.07 6 24 6",
    clipRule: "evenodd"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "pause-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m-3 30h-3V15h3zm9 0h-3V15h3z"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "play",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m41.22 22.68-30-16.5C10.23 5.64 9 6.36 9 7.5v33c0 1.14 1.23 1.86 2.22 1.32l30-16.5c1.02-.57 1.02-2.04 0-2.61z",
    clipRule: "evenodd"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "play-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3s21 9.402 21 21m-9.75-1.2-18.3-9.18v.06c-.9-.45-1.95.21-1.95 1.2v18.33c0 .99 1.05 1.65 1.95 1.2l18.3-9.18c.99-.51.99-1.92 0-2.43",
    clipRule: "evenodd"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "play-outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.25 22.8-18.3-9.18v.06c-.9-.45-1.95.21-1.95 1.2v18.33c0 .99 1.05 1.65 1.95 1.2l18.3-9.18c.99-.51.99-1.92 0-2.43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 24C3 12.39 12.39 3 24 3s21 9.39 21 21-9.39 21-21 21S3 35.61 3 24m39 0c0-9.93-8.07-18-18-18S6 14.07 6 24s8.07 18 18 18 18-8.07 18-18",
    clipRule: "evenodd"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26 8-.001 14H40v4H25.999L26 40h-4l-.001-14H8v-4h13.999L22 8z"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "presentation",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M33 18H15v3h18zM15 12h18v3H15z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 3v3h3v21c0 1.65 1.35 3 3 3h13.5v6.96l-8.34 5.55L15.81 45l8.16-5.46L32.13 45l1.65-2.49-8.34-5.55V30h13.5c1.65 0 3-1.35 3-3V6h3V3zm36 24H9V6h30z",
    clipRule: "evenodd"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "print",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42 15h-4.5V9c0-1.65-1.35-3-3-3h-21c-1.65 0-3 1.35-3 3v6H6c-1.65 0-3 1.35-3 3v16.5c0 1.65 1.35 3 3 3h4.5V42c0 1.65 1.35 3 3 3h21c1.65 0 3-1.35 3-3v-4.5H42c1.65 0 3-1.35 3-3V18c0-1.65-1.35-3-3-3M13.5 9h21v6h-21zm21 25.5V42h-21V30h21zm7.5 0h-4.5V27h-27v7.5H6V18h36z"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "regulation",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 9.21V3h-3v6.21C4.92 9.87 3 12.21 3 15s1.92 5.13 4.5 5.79V45h3V20.79c2.58-.66 4.5-3 4.5-5.79s-1.92-5.13-4.5-5.79m0 8.37c-.45.27-.96.42-1.5.42s-1.05-.15-1.5-.42C6.6 17.07 6 16.11 6 15s.6-2.07 1.5-2.58c.45-.27.96-.42 1.5-.42s1.05.15 1.5.42c.9.51 1.5 1.47 1.5 2.58s-.6 2.07-1.5 2.58M40.5 27.21V3h-3v24.21c-2.58.66-4.5 3-4.5 5.79s1.92 5.13 4.5 5.79V45h3v-6.21c2.58-.66 4.5-3 4.5-5.79s-1.92-5.13-4.5-5.79m0 8.37c-.45.27-.96.42-1.5.42s-1.05-.15-1.5-.42c-.9-.51-1.5-1.47-1.5-2.58s.6-2.07 1.5-2.58c.45-.27.96-.42 1.5-.42s1.05.15 1.5.42c.9.51 1.5 1.47 1.5 2.58s-.6 2.07-1.5 2.58M25.5 3v15.21c2.58.66 4.5 3 4.5 5.79s-1.92 5.13-4.5 5.79V45h-3V29.79c-2.58-.66-4.5-3-4.5-5.79s1.92-5.13 4.5-5.79V3zM24 27c.54 0 1.05-.15 1.5-.42.9-.51 1.5-1.47 1.5-2.58s-.6-2.07-1.5-2.58c-.45-.27-.96-.42-1.5-.42s-1.05.15-1.5.42c-.9.51-1.5 1.47-1.5 2.58s.6 2.07 1.5 2.58c.45.27.96.42 1.5.42",
    clipRule: "evenodd"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "rss",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.93 9c-1.32 0-2.64.09-3.9.3v5.28c1.26-.27 2.58-.39 3.9-.39 5.58 0 10.8 2.16 14.76 6.12 3.93 3.93 6.09 9.18 6.09 14.76 0 1.32-.12 2.64-.39 3.9h5.28c.21-1.26.3-2.58.3-3.9 0-14.4-11.67-26.1-26.07-26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.93 20.25c-1.35 0-2.67.18-3.9.54v5.49a9.53 9.53 0 0 1 10.68 1.98c1.8 1.8 2.82 4.26 2.82 6.81 0 1.35-.3 2.7-.84 3.9h5.49c.39-1.23.54-2.58.54-3.93 0-8.19-6.66-14.82-14.82-14.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.93 31.17c2.16 0 3.9 1.74 3.9 3.9s-1.74 3.9-3.9 3.9c-1.08 0-2.07-.42-2.76-1.14s-1.14-1.68-1.14-2.76c0-2.16 1.74-3.9 3.9-3.9M.09 37.14H0v-.36s.03.24.09.36M11.22 48c-.12 0-.36-.09-.36-.09V48z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "search",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M46.1 43.9 34.8 32.6C37.4 29.5 39 25.4 39 21c0-9.9-8.1-18-18-18S3 11.1 3 21s8.1 18 18 18c4.4 0 8.5-1.6 11.6-4.3L43.9 46zM6 21c0-8.3 6.7-15 15-15s15 6.7 15 15-6.7 15-15 15S6 29.3 6 21"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.473 26.003c.33 1.74 1.2 3.36 2.46 4.62h.06c.81.84 1.8 1.53 2.91 1.98 1.08.45 2.25.69 3.45.69 1.17 0 2.34-.24 3.45-.69 1.08-.45 2.07-1.14 2.91-1.98 1.26-1.26 2.1-2.88 2.46-4.62.36-1.77.18-3.57-.51-5.22a9.16 9.16 0 0 0-3.33-4.05 8.96 8.96 0 0 0-5.01-1.53c-1.77 0-3.54.54-5.01 1.53-1.5.99-2.64 2.4-3.33 4.05a8.9 8.9 0 0 0-.51 5.22m11.16-7.38c.75.33 1.41.78 1.95 1.35.57.57 1.05 1.23 1.35 1.95.33.72.48 1.5.48 2.31 0 .78-.18 1.59-.48 2.31-.33.75-.78 1.41-1.35 1.95-.57.57-1.23 1.05-1.95 1.35-.72.33-1.5.48-2.31.48-.78 0-1.59-.18-2.31-.48-.75-.33-1.41-.78-1.95-1.35-.57-.57-1.05-1.23-1.35-1.95-.33-.72-.48-1.5-.48-2.31 0-.78.18-1.59.48-2.31.33-.75.78-1.41 1.35-1.95.57-.57 1.23-1.05 1.95-1.35.72-.33 1.53-.48 2.31-.48s1.59.18 2.31.48",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M35.213 36.773v.03l.18 3.84c.03.69-.15 1.38-.57 1.95-.42.54-1.02.96-1.68 1.14l-6.69 1.83c-.51.15-1.05.15-1.56 0s-.99-.42-1.35-.78c-.24-.21-.42-.48-.57-.78l-1.71-3.45c-.72-.15-1.47-.36-2.19-.6l-3.21 2.13c-.6.39-1.32.57-2.01.48-.69-.06-1.35-.39-1.83-.9l-5.01-5.01c-.51-.48-.81-1.14-.9-1.83-.09-.72.09-1.41.48-2.01l2.13-3.21c-.24-.72-.45-1.44-.6-2.19l-3.45-1.71c-.27-.15-.54-.33-.78-.57-.39-.39-.63-.84-.78-1.35a2.76 2.76 0 0 1 0-1.56l1.74-6.75c.18-.69.6-1.29 1.17-1.71s1.26-.63 1.98-.57l3.81.21 1.62-1.62-.18-3.84c-.03-.69.15-1.38.57-1.95.42-.54 1.02-.96 1.68-1.14l6.75-1.74a2.76 2.76 0 0 1 1.56 0c.51.15.99.42 1.35.78.27.21.48.48.63.75l1.62 3.45c.72.15 1.47.36 2.19.6l3.21-2.13c.6-.39 1.32-.57 2.01-.48.69.06 1.35.39 1.83.9l4.98 4.98c.51.48.81 1.14.9 1.83.09.72-.09 1.41-.48 2.01l-2.13 3.21c.24.72.45 1.44.6 2.19l3.45 1.71c.27.15.54.33.78.57.39.39.63.84.78 1.35s.15 1.05 0 1.56l-1.74 6.75c-.18.69-.57 1.29-1.14 1.71s-1.26.6-1.98.57l-3.84-.27zm-12 .9 2.4 4.89 6.75-1.74-.27-5.52c1.29-.9 2.43-2.04 3.33-3.33l5.46.33 1.74-6.75-4.86-2.46c-.15-1.56-.54-3.09-1.2-4.53l3.03-4.53-5.01-5.01-4.56 3.06a13.3 13.3 0 0 0-4.56-1.2l-2.4-4.89-6.75 1.74.27 5.52c-1.29.9-2.43 2.04-3.33 3.33l-5.46-.33-1.74 6.75 4.86 2.46c.15 1.56.54 3.09 1.2 4.53l-3.03 4.53 5.01 5.01 4.56-3.06c1.44.66 2.97 1.08 4.56 1.2",
    clipRule: "evenodd"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "share",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M34.5 30c-2.34 0-4.41 1.11-5.79 2.79L17.67 26.1c.21-.66.33-1.38.33-2.1s-.12-1.38-.3-2.01l11.07-6.69c1.38 1.65 3.42 2.7 5.73 2.7 4.14 0 7.5-3.36 7.5-7.5S38.64 3 34.5 3 27 6.36 27 10.5c0 .75.15 1.47.36 2.16l-11.04 6.69c-1.38-1.71-3.45-2.82-5.82-2.82-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5c2.34 0 4.38-1.08 5.76-2.73l11.07 6.69c-.18.66-.33 1.32-.33 2.04 0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5-3.36-7.5-7.5-7.5zm0-24c2.49 0 4.5 2.01 4.5 4.5S36.99 15 34.5 15 30 12.99 30 10.5 32.01 6 34.5 6m-24 22.5C8.01 28.5 6 26.49 6 24s2.01-4.5 4.5-4.5S15 21.51 15 24s-2.01 4.5-4.5 4.5m24 13.5c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5 4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5",
    clipRule: "evenodd"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "shopping-bag",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M41.278 19.65a2.93 2.93 0 0 0-2.22-1.02h-3.12L28.318 6l-2.58 1.56 6.69 11.1h-16.86l6.72-11.1L19.708 6l-7.65 12.63h-3.06c-.84 0-1.65.36-2.22 1.02-.6.69-.87 1.62-.75 2.55l2.31 16.32c.21 1.53 1.5 2.7 2.97 2.7h25.35c1.5 0 2.82-1.17 3.03-2.73l2.31-16.32c.12-.93-.15-1.86-.75-2.55zm-4.59 18.6-25.35-.12-2.31-16.5 30.03.15-2.4 16.44z",
    clipRule: "evenodd"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "solid-arrow",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 30 12-15 12 15z"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "spinner",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.5 6h-3v9h3zM25.5 33h-3v9h3zM13.7 9.143l2.599-1.5 4.499 7.796-2.599 1.499zM29.818 31.063l-2.598 1.5 4.498 7.794 2.599-1.5zM7.652 16.312l1.5-2.598 7.795 4.5-1.5 2.598zM32.543 27.199l-1.5 2.598 7.794 4.5 1.5-2.598zM6 22.5h9v3H6zM42 22.5h-9v3h9zM7.64 31.691l7.795-4.5 1.5 2.598-7.794 4.5zM38.847 13.685l-7.792 4.503 1.5 2.597 7.793-4.503zM13.704 38.842l4.498-7.795 2.599 1.5-4.499 7.795z"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "spreadsheet",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42 3H6C4.35 3 3 4.35 3 6v36c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3M6 6h22.5v10.5H6zm13.5 22.5v-9h9v9zM6 19.5h10.5v9H6zM6 42V31.5h10.5V42zm36 0H19.5V31.5H42zm0-13.5H31.5v-9H42zm0-12H31.5V6H42z",
    clipRule: "evenodd"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "star-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.01 3 6.5 13.85 14.53 2.22-10.51 10.77 2.48 15.22-13-7.18-13 7.18 2.48-15.22L2.98 19.07l14.53-2.22z"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "star-outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m24 10.06 3.77 8.04.68 1.45 1.58.24 8.74 1.33-6.42 6.58-1.06 1.08.24 1.49 1.48 9.1-7.57-4.18-1.45-.8-1.45.8-7.57 4.18 1.48-9.1.24-1.49-1.06-1.08-6.42-6.58 8.74-1.33 1.58-.24.68-1.45 3.77-8.04m0-7.06-6.49 13.82-14.51 2.22 10.5 10.76L11 44.99l12.98-7.17 12.98 7.17-2.48-15.19 10.5-10.76-14.51-2.22z"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "success",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 2c12.198 0 22 9.81 22 22s-9.81 22-22 22S2 36.19 2 24 11.81 2 24 2m9.25 14-11 10.667-5.5-5.334L14 24l8 8 14-13.333z"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "tag",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.21 45.09h.016-.03zM15.016 15.03a3.75 3.75 0 0 1 5.31 0h-.03a3.75 3.75 0 0 1 0 5.31c-.72.75-1.68 1.11-2.64 1.11s-1.92-.39-2.64-1.11a3.75 3.75 0 0 1 0-5.31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.216 44.28c.536.537 1.25.807 1.994.81a3.05 3.05 0 0 0 2.146-.9l14.85-14.85c.57-.57.9-1.38.9-2.16 0-.75-.3-1.47-.84-2.01L22.906 3.81c-1.14-1.11-3-1.08-4.17.09l-2.7 2.76-7.77-.12c-.93.03-1.71.81-1.74 1.83l.09 7.65-2.73 2.73c-1.14 1.17-1.2 3.03-.06 4.17zM9.676 15.99l-.12-6.45 6.54.12c.78-.03 1.5-.36 2.04-.9l2.67-2.82 21.3 21.27-14.85 14.85-21.21-21.21 2.73-2.73c.54-.57.9-1.29.9-2.13",
    clipRule: "evenodd"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.47 9V6c0-1.65 1.35-3 3-3h9c1.65 0 3 1.35 3 3v3h10.5v3H6V9zm12 0V6h-9v3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 45H11.97c-1.65 0-3-1.35-3-3V13.47h3v28.56H36V13.47h3v28.56c0 1.65-1.35 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.97 36V18h-3v18zM26.97 36V18h3v18z"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "warning",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.996 6.314a.62.62 0 0 0-.535.317h.03L13.41 25.32 3.27 44.1c-.21.39.09.87.54.87h40.38a.59.59 0 0 0 .54-.87L34.59 25.32 24.51 6.63a.57.57 0 0 0-.514-.316M22.5 17.971h3V32.1h-3zM24 34.89c1.14 0 2.041.9 2.041 2.01S25.11 38.91 24 38.91a2.01 2.01 0 1 1 0-4.02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.b67647197d4d576ef51cc24878ee7174.svg";
export { ForwardRef as ReactComponent };